import {useEffect} from "react";
import axios from "axios";
import {PATHS_API} from "../../enum";

const PING_EVERY_MS = 30_000;

const newVisitorId = () =>
    typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
            (Number(c) ^ (Math.random() * 16) >> (Number(c) / 4)).toString(16));

// Сигнал «я на сайті» для лічильника онлайну в адмінці. id свій у кожної вкладки й живе, доки вона відкрита.
export const usePresence = () => {
    useEffect(() => {
        const id = newVisitorId();
        const ping = () => axios.post(PATHS_API.PRESENCE, { id }, { withCredentials: true }).catch(() => {});

        ping();
        const timer = window.setInterval(ping, PING_EVERY_MS);

        // закрили вкладку — одразу прибираємо її з онлайну (sendBeacon встигає відправитись під час закриття)
        const leave = () => navigator.sendBeacon?.(PATHS_API.PRESENCE, new Blob([JSON.stringify({ id, leave: true })], { type: "application/json" }));
        window.addEventListener("pagehide", leave);

        return () => {
            window.clearInterval(timer);
            window.removeEventListener("pagehide", leave);
        };
    }, []);
};
